import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $, { data } from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import StarRatings from 'react-star-ratings';

class C_Sat extends Component {
  constructor() {
    super();

    this.state = {
      utteranceDisplayName: '',
      startDate: new Date(),
      selectedDate: new Date(),
      escalatedChecked: false,
      attendedChecked: false,
      unattendedChecked: false,
      rating: 0,
      data: [{
        id: '',
        text: '',
        userId: '',
        valueType: '',
        description: '',
        valueType: [],
        userId: '',
        displayName: '',
        contactNumber: '',
        preferredLanguage: '',
        escalated: '',
        attendedChecked: '',
        unattendedChecked: '',
        date: '',
        conversationId: '',
        deleteRow: false,
      }],
      utData: [],
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      showUtterancePopUp: false

    }
    this.editImageSrc = "./assets/images/edit.svg";
    this.saveImageSrc = "./assets/images/save.svg";

    this.valueTypeVar = [];
  }

  notifyFailToCreate() {
    toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
      position: "top-center",
      color: "red"

    });
  }

  componentDidMount() {

    var thisController = this;
    var selectedDate = this.state.selectedDate;
    setTimeout(() => {
      thisController.state.utData = [];
      thisController.setState(thisController.state);
      thisController.fetchConversationLogData(selectedDate);
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      var selectedDate = thisController.state.selectedDate;
      thisController.state.utData = [];
      thisController.setState(thisController.state);
      thisController.projectId = event.projectId;
      thisController.fetchConversationLogData(selectedDate, event.projectId);
    });

  }

  escalatedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.escalatedChecked = e.target.checked;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    // var selectedDate = conversationLogController.state.selectedDate;
    // conversationLogController.fetchConversationLogData(selectedDate)
  }
  attendedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.attendedChecked = true;
    conversationLogController.state.unattendedChecked = false;
    // document.getElementById('Unattended').checked = false;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    // var selectedDate = conversationLogController.state.selectedDate;
    // conversationLogController.fetchConversationLogData(selectedDate)
  }
  unattendedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.unattendedChecked = true;
    conversationLogController.state.attendedChecked = false;
    // document.getElementById('Attended').checked = false;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    // var selectedDate = conversationLogController.state.selectedDate;
    // conversationLogController.fetchConversationLogData(selectedDate)
  }

  onChange = date => {
    this.state.selectedDate = date;
    this.state.utData = [];
    this.setState(this.state);
    // this.fetchConversationLogData(date);
  }

  fetchConversationLogData = (selectedDate, projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var conversationController = this;
    var longDate = new Date(selectedDate.toDateString()).getTime();

    $.ajax({
      url: "/api/reported-conversation",
      async: false,
      method: 'GET',
      data: {
        projectId: projectId,
        date: longDate,
        escalationChecked: this.state.escalatedChecked,
        attendedChecked: this.state.attendedChecked,
        unattendedChecked: this.state.unattendedChecked,
        cSatScore: conversationController.state.rating
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          conversationController.setState({
            data: tagKeys,
            successResp: true
          })
        }


      },

    });
  }

  fetchUtterancesApi = (id, supportUserName) => {
    var utteranceController = this;

    $.ajax({
      url: "/api/utterances/",
      async: false,
      method: 'GET',
      data: { conversationId: id },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token"), },
      success: function (res) {
        if (res.success === true) {

          var source = { "supervisorUserName": supportUserName };
          var data = [];
          for (var i = 0; i < res.result.length; i++) {
            data[i] = Object.assign(res.result[i], source);
          }
          utteranceController.setState({
            utData: data,
            successResp: true
          });
        } else {
          utteranceController.notifyFailToCreate();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }
  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  }
  handleChangeForUtterance = (id, supportUserName) => {
    this.state.showUtterancePopUp = true;
    this.setState({
      text: this.state.value,

    });
    this.fetchUtterancesApi(id, supportUserName);
  }

  changeRating = (rating) => {
    var conversationLogController = this;
    conversationLogController.state.rating = rating;
    conversationLogController.setState(conversationLogController.state);
    // var selectedDate = conversationLogController.state.selectedDate;
    // conversationLogController.fetchConversationLogData(selectedDate)
  }

  render() {
    const { data } = this.state
    const columns1 = [

      {
        width: 250,
        Header: '',
        minWidth: 17,
        textAlign: 'screenLeft',
        accessor: 'text',
        sortable: false,
        cellStyle: { border: 'none' },
        headerStyle: { marginTop: '-10px' },
        Cell: props =>
        (

          <div class="card-body chat_body log_one" style={{ display: props.original.text != "" ? 'block' : 'none' }}>
            <div className={(props.original.incoming == false) ? "direct-chat-msg" : "direct-chat-msg right"}>
              <div className={(props.original.incoming == false) ? "direct-chat-text chat_left textarea" : "direct-chat-text chat_right textarea"}
                style={{
                  display: props.original.id != "" || props.original.id != undefined ||
                    props.original.id != null || props.original.text != null ? "block" : "none",
                  marginTop: "5px", width: "200%", height: "auto",
                  backgroundColor: props.original.incoming == false ? "#ead5d5" : "#e1e1f5",
                  marginTop: '-10px', borderBottom: 'none',
                  textAlign: props.original.incoming == false ? "left" : "right",
                  marginLeft: props.original.incoming == false ? "0px" : "20vw"
                }}>
                <font id={"text" + props.index} readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}>{(props.original.supervisorUserName != null && !props.original.incoming) ? "[" + props.original.supervisorUserName + "]  " + props.original.text : props.original.text}
                </font>
              </div>
            </div>
          </div>
        )
      },
    ]

    const columns =
      [
        {
          Header: 'Id',
          accessor: 'id',
          show: false,
          Cell: props => (
            <div name="id" id={"id" + props.index}>{props.original.id}
            </div>)
        },

        {
          Header: () => (''),
          accessor: 'userId',
          sortable: false,
          headerStyle: { marginTop: '-10px' },
          Cell: props => (
            <div name="userId">

              <b>User Name :</b><font
                style={{ color: 'none', border: 'none', background: 'white', resize: 'none', marginLeft: '5px', marginRight: '20px' }}
                id={"displayName" + props.index}>{props.original.displayName}
              </font>
              <b>Start Time :</b><font
                style={{ color: 'none', border: 'none', background: 'white', resize: 'none', marginLeft: '5px' }}
                id={"displayName" + props.index}>{(new Date(props.original.startTime)).toLocaleString()}
              </font><br />
              <b>Contact Number :</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '5px', marginRight: '20px' }}
                id={"contactNumber" + props.index}>{props.original.contactNumber}
              </font >
              <b>Language :</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"preferredLanguage" + props.index}>{props.original.preferredLanguage}
              </font >

              <b>Escalated : </b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"escalationChecked" + props.index}>{props.original.escalated ? "Yes" : "No"}
              </font ><br />
              <b> Last Supervision By:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"userId" + props.index}>{props.original.lastSupportUserId == null ? 'NA' : props.original.lastSupportUserId}
              </font ><br />
              <b>Location Lat:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"latitude" + props.index}>{props.original.latitude == null ? 'NA' : props.original.latitude}
              </font >
              <b>Location Longt:</b><font
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"longitude" + props.index}>{props.original.longitude == null ? 'NA' : props.original.longitude}
              </font ><br />

            </div>)
        },
        {
          Header: () => (''),
          accessor: 'c_sat_score',
          sortable: false,
          headerStyle: { marginTop: '-10px' },
          Cell: props => (
            <div name="c_sat_score" style={{ textAlign: "center" }}>
              <StarRatings
                rating={props.original.csatScore}
                starRatedColor="#FFC000"
                starHoverColor="#FFC000"
                numberOfStars={5}
                starDimension="20px"
                name="C-SAT Scores" />
              <br />
              <b
                style={{ border: 'none', background: 'white', resize: 'none', marginLeft: '6px', marginRight: '25px' }}
                id={"userFeedback" + props.index}>"{props.original.userFeedback}"</b>
              <br />
            </div>
          )
        },
        {
          Header: () => (''),
          accessor: 'conversation',
          sortable: false,
          headerStyle: { marginTop: '-10px' },
          Cell: props => (
            <div name="conversation" style={{ textAlign: "center" }}>
              <div Align="center">
                <button className="btn2 table-action-button "
                  title="View conversation"
                  style={{ borderRadius: '4px' }}
                  onClick={() => {
                    this.handleChangeForUtterance(props.original.id, props.original.lastSupportUserId);
                  }}
                >View conversation</button>
              </div>
            </div>
          )
        },
        {
          Header: () => (
            'userId'),
          accessor: 'userId',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="userId">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"userId" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.userId}
              </textarea>
            </div>)
        },
        {
          Header: () => (
            'displayName'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },


        {
          Header: () => (
            'contactNumber'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'preferredLanguage'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'escalationChecked'),
          accessor: 'displayName',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="displayName">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"displayName" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.displayName}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'attendedChecked'),
          accessor: 'attendedChecked',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="attendedChecked">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"attendedChecked" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.attendedChecked}
              </textarea>
            </div>)
        },

        {
          Header: () => (
            'date'),
          accessor: 'date',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="date">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"date" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.date}
              </textarea>
            </div>)
        },
        {
          Header: () => (
            'conversationId'),
          accessor: 'conversationId',
          sortable: false,

          show: false,
          Cell: props => (
            <div name="conversationId">
              <textarea
                style={{ border: 'none', background: 'white', resize: 'none' }}
                id={"conversationId" + props.index}
                class="form-control"
                rows="1"
                maxlength="250"
                readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}
              >{props.original.conversationId}
              </textarea>
            </div>)
        },

      ]


    return (
      <div visible={(this.state.successResp) ? false : true}>

        <div style={{
          background: "#F9F9FB", marginLeft: '1%', marginRight: '1%',
        }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="./assets/css/react.table.border.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          {/* <div className="wrapper"> */}
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          {/* ----new style------------------------------- */}
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="dist/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <style media="screen" dangerouslySetInnerHTML={{ __html: "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  " }} />


          {/* for checkbox component */}
          <link rel="stylesheet" href="./assets/css/combobox-style.css" />
          <link rel="stylesheet" href="assets/css/Checkbox/Checkboxbutton.css" />
          <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />


          <div className="container-fluid">
            <div className="row" style={{ marginTop: '0%' }}>
              <div className="col-sm-3">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '0%' }}>C-SAT Scores</h6>
                <h6></h6>
              </div>

              <div className="col-sm-2" style={{ marginLeft: '0%' }}>
                <div className="p" style={{ cursor: "pointer" }}>
                  <b>DATE : <DatePicker
                    style={{ width: '20px', marginLeft: '70%', cursor: "pointer" }}
                    id="date"
                    selected={this.state.selectedDate}
                    onChange={this.onChange}
                    dateFormat="dd/MM/yyyy">
                  </DatePicker>
                  </b>
                </div> </div>
              <div className="col-sm-3" style={{ marginLeft: '0%' }}>
                <b>Select C-SAT Score : </b>
                <StarRatings
                  rating={this.state.rating}
                  starRatedColor="#FFC000"
                  starHoverColor="#FFC000"
                  changeRating={this.changeRating}
                  numberOfStars={5}
                  name='rating'
                  starDimension="30px"
                />
              </div>
              <div className="col-sm-4 row" style={{ marginTop: '1%' }} >

                <p style={{ width: '55%' }}>
                  <CheckBoxComponent label="Escalated" style={{ backgroundColor: '#282a65' }} id="Escalated"
                    onClick={this.escalatedChecked} />
                  <input type="radio" style={{ marginLeft: '5%', accentColor: '#282a65' }}
                    id="Attended" onClick={this.attendedChecked} value="Attended" checked={this.state.attendedChecked === true} />
                  <label for="Attended" style={{ marginLeft: '2%', color: 'black' }}>Attended</label>
                  <input type="radio" style={{ marginLeft: '5%', accentColor: '#282a65' }}
                    id="Unattended" onClick={this.unattendedChecked} value="Unattended" checked={this.state.unattendedChecked === true} />
                  <label for="Unattended" style={{ marginLeft: '2%', color: 'black' }}>Unattended</label>

                </p>
                <button className="btn action-button"
                  style={{ marginTop: '-10px', marginLeft: '5%' }}
                  onClick={() => { this.fetchConversationLogData(this.state.selectedDate) }}>
                  Search
                </button>
                <button className="btn action-button"
                  style={{ marginTop: '-10px', marginLeft: '5%' }}
                  onClick={this.refreshData}
                  title="Refresh">
                  <img src="./assets/images/refresh_white_24dp.png" />
                </button>

              </div>
            </div>
          </div>
          {/* /.content-header */}
          <div className="content" style={{ marginTop: "10px" }}>
            <div className="container-fluid" >
              <div className="row"
                style={{ marginRight: '2%' }}  >
                <div className="col-lg-12" >
                  <div className="card" style={{ height: "570px", overflowY: data.length > 4 ? "scroll" : "hidden" }}>
                    <div>
                      <ReactTable
                        style={{
                          display: this.state.successResp ? 'block' : 'none',
                        }}
                        data={data}
                        columns={columns}
                        pageSize={data.length > 5 ? data.length : 5}
                        showPagination={false}
                      />
                    </div>
                  </div>
                  <ToastContainer classname="Toast-at-center" />
                </div>
                <div></div>
                {/* <div class="col-lg-6">
                  <div className="card" style={{ height: "570px", overflowY: "auto" }}>
                    <div class="table-responsive logTableBox">

                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

        </div>
        <div className="modal" style={{ display: this.state.showUtterancePopUp ? 'block' : 'none' }}>
          <div className="modal-dialog" id="center-aligned-account-modal">
            <div className="modal-content" style={{ height: "600px", width: "900px" }}>
              <div className="modal-header noBorder">
                <div className="row" style={{ marginTop: '-30px' }}>
                  <div className="col-sm-12" align="center">
                    <h1 className="m-0 page-title">Conversation Utterances</h1>
                  </div>
                </div>
                <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => { this.setState({ showUtterancePopUp: false }) }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <ReactTable id='reactTable'
                    data={this.state.utData}
                    columns={columns1}
                    showPagination={false}
                    pageSize={this.state.utData.length <= 5 ? 5 : this.state.utData.length}
                    style={{ height: '500px' }}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default C_Sat;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/conversation/C_Sat.js